module.exports = __webpack_public_path__ + "img/nebl.032f04e8.svg";